import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'userManagement.3pc.error.title' }),
    description: translate({ id: 'userManagement.3pc.error.description' }),
  }))

  return api
}
